import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'iceberg', 'Iceberg', [["path",{"d":"M19 10l-2 9l-4 3l-3 -5l-3 -1l-2 -6l2 -5l3 -2l3 3l4 1l2 3"}],["path",{"d":"M3 10h18"}]]);